import { NavMenu } from '@shopify/app-bridge-react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Accepted } from '../model/key';

// NavMenu (ui-nav-menu) reads its anchor children for labels/hrefs; React
// Router's <Link> renders an <a> but navigates client-side, so nav clicks
// don't trigger a full page reload (which would drop the Redux store).
function AppNavMenu({ sellerStatus }) {
    return (
        <NavMenu>
            <Link to="/account">Account</Link>
            {sellerStatus === Accepted && <Link to="/products">Products</Link>}
            {sellerStatus === Accepted && <Link to="/orders">Orders</Link>}
        </NavMenu>
    );
}

const mapStateToProps = state => ({ sellerStatus: state.userConfig?.sellerStatus });
export default connect(mapStateToProps)(AppNavMenu);
